import "../styles/ContactUs.css";

const zambiaBranches = [
  { name: "Levy", phone: "+260975444888" },
  { name: "East Park", phone: "+260764971723" },
  { name: "Centro", phone: "+260972562055" },
  { name: "Kitwe", phone: "+260770569757" },
];

const ugandaBranches = [
  { name: "Acacia Mall", phone: "+256 758603842" },
  { name: "Arana Mall", phone: "+256 758991972" },
];

function ContactUs() {
  return (
    <div className="contact-page">
      <header className="top-header">
        <img
          src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/yashikaLogo.png"
          alt="Yashika"
          className="logo"
        />
      </header>

      <div className="page-container">
        <h1>Hello, it’s Yashika Fashion Boutique!</h1>

        <p className="sub-title">
          Pick your spot, explore our collections, and enjoy effortless style.
        </p>

        <section className="card-section container">
          <div className="section-title">
            <h2>Our Profile</h2>
            <span></span>
          </div>

          <div className="profile-buttons">
            <a
              href="https://wa.me/260975444888"
              target="_blank"
              rel="noreferrer"
              className="profile-btn whatsapp"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/whatsapp.png"
                alt=""
              />
              WhatsApp
            </a>

            <a
              href="mailto:sales.zm@yashikafashions.com"
              className="profile-btn email"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/email.png"
                alt=""
              />
              Email
            </a>
          </div>
        </section>

        <section className="container card-section">
          <div className="section-title">
            <h2>Connect with Our Branches</h2>
            <span></span>
          </div>

          <div className="branches-grid">
            {zambiaBranches.map((branch) => (
              <a
                key={branch.name}
                href={`https://wa.me/${branch.phone.replace("+", "")}`}
                className="branch-card"
              >
                <img
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/whatsapp.png"
                  alt=""
                />

                <div>
                  <h4>{branch.name}</h4>
                  <p>{branch.phone}</p>
                </div>
              </a>
            ))}
          </div>
        </section>

        <h1>Your Wardrobe, Your Way</h1>

        <p className="sub-title">
          Fashion that's fun, easy, and made to brighten your day.
        </p>

        <section className="card-section">
          <div className="section-title">
            <h2>Our Profile</h2>
            <span></span>
          </div>

          <div className="profile-buttons">
            <a
              href="https://wa.me/256759406691"
              target="_blank"
              rel="noreferrer"
              className="profile-btn whatsapp"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/whatsapp.png"
                alt=""
              />
              WhatsApp
            </a>

            <a
              href="mailto:hyashikainternational.ug@gmail.com"
              className="profile-btn email"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/email.png"
                alt=""
              />
              Email
            </a>
          </div>
        </section>

        <section className="card-section">
          <div className="section-title">
            <h2>Connect with Our Branches</h2>
            <span></span>
          </div>

          <div className="branches-grid">
            {ugandaBranches.map((branch) => (
              <a key={branch.name} href="/" className="branch-card">
                <img
                  src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/whatsapp.png"
                  alt=""
                />

                <div>
                  <h4>{branch.name}</h4>
                  <p>{branch.phone}</p>
                </div>
              </a>
            ))}
          </div>
        </section>

        <div className="social-section">
          <div className="section-title">
            <h2>Social links</h2>
            <span></span>
          </div>

          <div className="social-icons">
            <a
              href="https://www.instagram.com/yashikafashion_store/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/Instagram.png"
                alt=""
              />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61579531656770"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/BBTLink/Facebook.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      <footer className="footer">
        <strong>© 2026 yashikastore.</strong> All rights reserved.
      </footer>
    </div>
  );
}

export default ContactUs;